import React from 'react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';

const TextEditor = ({ textData, setTextData }) => {
  const editorConfig = {
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph',
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'ck-heading_heading1',
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2',
        },
      ],
    },
    toolbar: [
      'fontfamily',
      'fontcolor',
      'highlight',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'link',
      '|',
      'bulletedList',
      'numberedList',
      'insertTable',
      '|',
      'alignment',
      'outdent',
      'indent',
      '|',
      'undo',
      'redo',
    ],
    link: {
      addTargetToExternalLinks: true,
    },
    mediaEmbed: {
      removeProviders: [
        'instagram',
        'twitter',
        'googleMaps',
        'flickr',
        'facebook',
        'youtube',
        'vimeo',
        'spotify',
        'dailymotion',
      ],
    },
  };

  const handleData = (event, editor) => {
    const data = editor.getData();
    setTextData(data);
  };

  return (
    <div className="CkEditor">
      <CKEditor
        editor={Editor}
        data={textData}
        onChange={handleData}
        config={editorConfig}
      />
    </div>
  );
};

export default TextEditor;
